<template>
<div>
  <v-container fluid grid-list-md class="padding_10">

    <v-expansion-panel class="mb-4">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Filters</div>
        </template>
        <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
          <v-flex sm12 md6 lg4>
            <v-autocomplete
              label="Start typing to search name"
              v-model="filters.name"
              :items="userList"
              :item-text="getItemText"
              item-value="id"
              :loading="isLoading"
              chips clearable
              name="name"
              :search-input.sync="search_name" solo flat
              style="padding-top: 0px; margin-top: 0px;"
          ></v-autocomplete>
          </v-flex>
          <v-flex sm12 md6 lg3>
            <v-menu
                v-model="filterStartDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                style="padding-top: 10px;"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="filters.startDate"
                    label="Start Date"
                    readonly
                    v-bind="attrs"
                    v-on="on" clearable solo flat
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="filters.startDate"
                  @input="filterStartDateMenu = false" :max="filters.endDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm12 md6 lg3>
            <v-menu
                v-model="filterEndDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                style="padding-top: 10px;"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="filters.endDate"
                    label="End Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable solo flat
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="filters.endDate"
                  @input="filterEndDateMenu = false" :max="current_date" :min="filters.startDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm12 md12 lg2 style="display: flex; justify-content: center; padding-bottom: 15px; margin-top: -17px;">
            <v-btn type="submit" @click="applyFilters(filters)" color="primary" class="mt-3">
              Filter
            </v-btn>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card
      class="mx-auto"
      tile>
<!--      itemsWithSno-->
      <v-data-table
          :headers="headers"
          :items="list"
          :loading="loader"
          class="elevation-1"
          :rows-per-page-items="[10,25,50]"
          :pagination.sync="pagination"
          :total-items="total_items">
        <template v-slot:items="props">
          <td style="width: 20px;">
            <v-badge overlap left color="white">
<!--              <template v-slot:badge v-if="props.item.srNo <= 3">-->
<!--&lt;!&ndash;                <v-icon class="material-icons" style="font-size: 23px; color: mediumvioletred">stars</v-icon>&ndash;&gt;-->

<!--                <v-icon  small v-if="props.item.srNo == 1" style="font-size: 23px; color:gold">stars</v-icon>-->
<!--                <v-icon dark small v-if="props.item.srNo == 2" style="font-size: 23px; color:silver">stars-->
<!--                </v-icon>-->
<!--                <v-icon dark small v-if="props.item.srNo == 3" style="font-size: 23px; color:saddlebrown">stars-->
<!--                </v-icon>-->
<!--              </template>-->

              <v-avatar color="purple red--after" :size="40">
                <img
                    :src="props.item.image_url != null ? storage_path()+props.item.profile_pic :
              '/images/default_user.png'"                    alt="John"
                >
              </v-avatar>

            </v-badge>
          </td>
          <td>{{ props.item.first_name + " " + props.item.last_name}}</td>
          <td>{{ props.item.points }}</td>
          <td>{{props.item.srNo}}</td>

        </template>
      </v-data-table>
    </v-card>


    <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
      {{ snackbar.message }}
      <v-btn
          text
          dark
          @click="snackbar.display = false"
      >
        <v-icon
            right
            color="white"
        >
          close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</div>
</template>

<script>
import moment from "moment";

export default {
  name: "Index",
  watch: {
    pagination: {
      handler() {
        // this.getRankingList();
      }
    },
    search_name: function(val){
        if (val != null && val.length >= 3) {
          this.isLoading = true;
          this.getUserList();

        }

      if(val == null || val == undefined){
        this.filters.startDate = '';
        this.filters.endDate = '';
        this.getRankingList();
      }
    },
    "filters.endDate": function (val){
      if(val == ''){
        this.filters.endDate = moment().format('YYYY-MM-DD')
        if(val == null || val == undefined){
          this.filters.startDate = '';
          this.filters.endDate = '';
          this.getRankingList();
        }
      }
    },
    "filters.startDate": function (val){
      if(val == null || val == undefined){
        this.filters.startDate = '';
        this.filters.endDate = '';
        this.getRankingList();
      }
    }
  },
    data: () => ({
      filters: {
        name: '',
        startDate: '',
        endDate: '',
      },
      // moment().format('YYYY-MM-DD')
      filterStartDateMenu: false,
      filterEndDateMenu: false,
      filter_dialog_box: false,
      total_items: 0,
      filter_chips: {},
      pagination: {sortBy: "updated_at", descending: true, rowsPerPage: 10},
      headers: [

        { text: '', value: '' },
        { text: 'Name', value: 'name' },
        { text: 'Points', value: 'points' },
        { text: 'Ranking', value: 'ranking' },
      ],
      list: [],
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      userList: [],
      loader: false,
      search_name: "",
      search:'',
      isLoading: false,
      current_date: ''
    }),
  methods:{
    applyFiltersOnLoad:function(){
      if(this.$route.query.filters){
        this.filters.name = this.$route.query.name;
        this.filters.startDate = this.$route.query.startDate;
        this.filters.endDate = this.$route.query.endDate;
      }
    },

    validateBeforeSubmit: function(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    applyFilters() {
      this.getRankingList();
    },
    getRankingList(){
      this.pagination.filters = Object.assign({}, this.filters);
        axios.get(`${process.env.VUE_APP_API_URL}/api/v1/ranking-user-list`,
            {
              params: this.pagination,
              headers: this.$headers
            }).then(response => {
        if (response.data.status == 1) {
          let result = Array.isArray(response.data.data);

          if(result == false){
            this.list = [];
            const abc = response.data.data;
            this.list.push(abc) ;
          }else{
            this.list = response.data.data;
          }
        }
      }).catch((error) => {
        console.log(error)
        this.snackbar.message = "Something went wrong";
        this.snackbar.display = true;
      });
    },
    getUserList(){
      this.loader = true;
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-user-list`, {headers: this.$headers}).then(response => {
        if (response.data.status == 1) {
          this.userList = response.data.data;
          this.loader = false;
        }else if(response.data.status == 0){
          this.loader = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        this.loader = false;
        this.snackbar.message = "Something went wrong";
        this.snackbar.display = true;
      });
    },
    getItemText(item) {
      return `${item.first_name} ${item.last_name}`;
    }
  },
  computed: {
    // itemsWithSno() {
    //   var finalArray = []
    //   const result = this.list.map(function (d, index, elements){
    //
    //     if(index != 0){
    //       var previous = elements[index - 1];
    //       var srno = elements[index - 1].sno;
    //       if(d.referral_count != previous.referral_count)
    //       {
    //         var srno = srno + 1;
    //         d.sno = srno;
    //         finalArray.push(d);
    //       }else{
    //         var srno = srno
    //         d.sno = srno;
    //         finalArray.push(d);
    //       }
    //     }else{
    //       var srno = index + 1
    //       d.sno = srno;
    //       finalArray.push(d);
    //     }
    //  })
    //   this.finalArray1 = finalArray;
    //     return finalArray;
    //   // return this.list.map((d, index) => ({
    //   //
    //   //   ...d, sno: index + 1
    //   // }))
    // }


  },
  mounted() {
    this.applyFiltersOnLoad();
    this.current_date = moment().format('YYYY-MM-DD');
    // this.getRankingList();
  }
}
</script>

<style scoped>

</style>
